"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_notifications__muted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "4ac63748-5da0-4cb5-af27-727dee004d07",
    "data-name": "notifications-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "31543760-f5ad-4254-948f-d91b00eaa05b",
    x1: 93.16,
    y1: 157.2,
    x2: 105.82,
    y2: 169.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "700c6b6c-3438-4c4a-a61d-37f3ab003e3a",
    x1: 84,
    y1: 23.08,
    x2: 142.14,
    y2: 81.21,
    xlinkHref: "#31543760-f5ad-4254-948f-d91b00eaa05b"
  })), /*#__PURE__*/React.createElement("title", null, "notifications-muted-hi"), /*#__PURE__*/React.createElement("g", {
    id: "31360a2d-6ef9-4088-a5b2-9e78ae850184",
    "data-name": "24/7_support_ic_hi 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1bfaac24-3761-4f7f-a310-53338f308f0d",
    "data-name": "Notification_ic_hi 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.78,79l-.37-12.42-.17-6.11a32.49,32.49,0,0,0-9.7-19.39c-.81-.77-1.66-1.5-2.54-2.19V37.77c0-2.17-3.58-5.75-8-5.75h-.1V28A11.84,11.84,0,0,0,96,16,12,12,0,0,0,84,28v4h-.1C79.58,32,76,35.6,76,37.77v1.16c-.88.69-1.73,1.42-2.54,2.19a32.43,32.43,0,0,0-9.69,19.35l-.18,6.19L63.23,79A118.28,118.28,0,0,1,53.1,123h85.79A118.24,118.24,0,0,1,128.78,79ZM87.91,28A8.12,8.12,0,0,1,96,20a8,8,0,0,1,8,8v4l-8.1,0-8,0Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,158a9,9,0,1,0,9,9A9,9,0,0,0,96,158Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174a9,9,0,0,1-8.94-8,8.26,8.26,0,0,0-.06,1,9,9,0,0,0,18,0,8.26,8.26,0,0,0-.06-1A9,9,0,0,1,96,174Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.64,160H90.36l-.06,0L103,172.72a9,9,0,0,0-1.32-12.7Z",
    opacity: 0.2,
    fill: "url(#31543760-f5ad-4254-948f-d91b00eaa05b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.83,161a4,4,0,0,0,3.8-5l-.81-2.85c-2-8-4.64-11.19-10.26-17.21a31.77,31.77,0,0,1-4.62-6.37c-.45-.8-.87-1.72-1.29-2.54H51.35c-.42.82-.84,1.74-1.29,2.54a31.77,31.77,0,0,1-4.62,6.37h0c-5.62,6-8.24,9.23-10.26,17.21L34.37,156a4,4,0,0,0,3.8,5H153.83Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.89,123H53.1c-.61,1.3-1.09,2.74-1.76,4h89.31C140,125.75,139.5,124.3,138.89,123Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 30,
    width: 3.9,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 30,
    width: 3.9,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.78,79l-.37-12.42-.17-6.11a32.49,32.49,0,0,0-9.7-19.39c-.81-.77-1.66-1.51-2.54-2.2V37.77c0-2.16-3.57-5.74-8.08-5.75V28A11.87,11.87,0,0,0,96,16,12,12,0,0,0,84,28v4h0c-4.42,0-8,3.58-8,5.75v1.15l-.09.08,54.22,54.22A115.71,115.71,0,0,1,128.78,79ZM104,32H97.67c-.56,0-1.11,0-1.67,0s-1.11,0-1.67,0H87.92V28A8.11,8.11,0,0,1,96,20a8,8,0,0,1,8,8Z",
    opacity: 0.2,
    fill: "url(#700c6b6c-3438-4c4a-a61d-37f3ab003e3a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6,37h38.8a.6.6,0,0,1,.6.6V39a0,0,0,0,1,0,0H76a0,0,0,0,1,0,0V37.6A.6.6,0,0,1,76.6,37Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.83,159H38.17a4,4,0,0,1-3.82-2.95A4,4,0,0,0,38.17,161H153.83a4,4,0,0,0,3.82-4.95A4,4,0,0,1,153.83,159Z",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("line", {
    id: "b136633b-6fa2-475b-9ed5-aeeaf35dff11",
    "data-name": "93ff4d18-3497-45db-b877-d4ab9e8b4a69",
    x1: 34.01,
    y1: 173.81,
    x2: 158.41,
    y2: 49.41,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }));
}

var _default = ic_notifications__muted;
exports.default = _default;